<template>
    <el-tooltip :content="title" effect="light" :open-delay="200" placement="top">
        <small class="border rounded px-2 font-weight-bold mr-2"
            :class="this.style">
            {{ name }}
        </small>
    </el-tooltip>
</template>
<script>

export default {
    props: {
        name: {
            type: String,
            default: "TEST"
        }
    },
    computed: {
        title () {
            if( this.name === 'ETFP') return "Electronic ETF, ETC/ETN and Open-End Funds Market";
            if( this.name === 'MTAA') return "Electronic Share Market";
            if( this.name === 'TNLB') return "Euronext - Trading Facility Brussels";
            if( this.name === 'XAIM') return "AIM Italia - Mercato Alternativo Del Capitale";
            if( this.name === 'XAMS') return "Euronext - Euronext Amsterdam";
            if( this.name === 'XBRU') return "Euronext - Euronext Brussels";
            if( this.name === 'XDUB') return "Irish Stock Exchange - All Market";
            if( this.name === 'XETR') return "Xetra";
            if( this.name === 'XHEL') return "Nasdaq Helsinki Ltd";
            if( this.name === 'XLIS') return "Euronext - Euronext Lisbon";
            if( this.name === 'XLON') return "London Stock Exchange";
            if( this.name === 'XLUX') return "Luxembourg Stock Exchange";
            if( this.name === 'XMAD') return "Bolsa De Madrid";
            if( this.name === 'XPAR') return "Euronext - Euronext Paris";
            if( this.name === 'XWBO') return "Wiener Boerse AG";
            return this.name;
        },
        style() {
            if( this.name === 'ETFP') return 'border-primary text-primary';
            if( this.name === 'MTAA') return 'border-primary text-primary';
            if( this.name === 'XPAR') return 'border-info text-info';
            if( this.name === 'XBRU') return 'border-success text-success';
            if( this.name === 'TNLB') return 'border-success text-success';
            if( this.name === 'XDUB') return 'border-success text-success';
            if( this.name === 'XMAD') return 'border-danger text-danger';
            if( this.name === 'XLIS') return 'border-danger text-danger';
            if( this.name === 'XAIM') return 'border-danger text-danger';
            if( this.name === 'XLUX') return 'border-warning text-warning';
            if( this.name === 'XAMS') return 'border-warning text-warning';
            if( this.name === 'XWBO') return 'border-warning text-warning';

            if( this.name === 'XLON') return '';
            if( this.name === 'XHEL') return '';
            if( this.name === 'XETR') return '';
        }
    }
  }
</script>
<style>
</style>